<template>
  <b-modal 
    :id="is_preview ? 'statement-modal-preview' : 'statement-modal'" 
    size="lg" 
    hide-footer
    :no-close-on-esc="!bit && !is_preview"
    :no-close-on-backdrop="!bit && !is_preview"
    :hide-header="!bit && !is_preview"
  >
    <statement :newAnnouncementData="newAnnouncementData" @hide="hide" :bit="bit" :is_preview="is_preview" />
  </b-modal>
</template>
  
  <script>
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { $themeConfig } from "@themeConfig";
import statement from "@/views/pages/authentication/statement.vue";
import store from "@/store";

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BModal,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BOverlay,
    statement
  },
  props:{
    bit: {
      type: Boolean,
      default: false,
    },
    is_preview: {
      type: Boolean,
      default: false,
    },
    newAnnouncementData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  mounted() {},
  computed: {},
  methods: {
    hide(){
      this.$bvModal.hide('statement-modal')
    }
  },
};
</script>
  
<style lang="scss">
body .swal2-container.swal2-backdrop-show {
  z-index: 99999999!important;
}
</style>
<style lang="scss" scoped>
#statement-modal___BV_modal_outer_{
  z-index: 999999!important;
}
</style>